import "../McqCard/mcqCard.css";
import "../TestQuestions/Question.css";
import { useEffect, useMemo, useState } from "react";
import { useMediaQuery } from "react-responsive";

import EditCard from "../../EditCard/EditCard";

import { Option, QuestionImg } from "../TestQuestions/Component";
import QuestionChecker from "../TestQuestions/QuestionChecker";

import { htmlDecode } from "../../../utils/parse";
import { Checkbox } from "@material-ui/core";
import CognitiveIcon from "../TestQuestions/Component/CognitivieIcon";

export default function AssertiveAndReasoning({
  isPraticeSession,
  isChecked,
  question,
  index,
  deleteQuestion,
  setQuestId,
  setSelQuest,
  reviewQuestion,
  page,
  getTotalMarks,
  setReviewQuestion,
  setChecked,
  setChaptersState,
  chaptersState,
  setTopicsState,
  setCheckMarksState,
  topicsState,
}) {
  const isSmallScreen = useMediaQuery({
    query: "(max-width:450px)",
  });
  const [edit, setEdit] = useState(false);
  const openEdit = () => setEdit(true);
  const closeEdit = () => setEdit(false);

  const [selectedOption, setSelectedOption] = useState({});

  const { explanation, option } = useMemo(() => {
    return (
      question.correctAnswers["assertion-reasoning"] || {
        explanation: "",
        option: "",
      }
    );
  }, [question.correctAnswers]);

  function isSelected(opt) {
    return option === opt.optionId;
  }

  const isCorrectOption = (optionId) => {
    if (!question.correctAnswers) return false;
    return option === optionId;
  };

  useEffect(() => {
    if (window.MathJax) {
      window.MathJax.typesetPromise();
    }
  }, [question.question]);

  return (
    <>
      {edit && (
        <EditCard
          edit={edit}
          closeEdit={closeEdit}
          quesType="mcq"
          question={question}
          setQuestId={setQuestId}
          setSelQuest={setSelQuest}
          isMarks={false}
          assessmentType={"competency"}
        />
      )}
      <div
        className={
          isChecked
            ? "my-4 question-c onlineQuestionCard"
            : "my-4 question-c questionCard"
        }
        style={{ display: edit ? "none" : "block" }}
      >
        <div className="superhead">
          <div
            className={
              isPraticeSession ? "remark ps_remark" : "remark ot_remark"
            }
          >
            Assertion and Reasoning
          </div>
          <div
            className={
              isPraticeSession
                ? "mcq__head ps_mcq_head"
                : "mcq__head ot_mcq_head"
            }
          >
            <QuestionChecker
              isStaff={question.onModel === "staff"}
              type={question.questionType}
              correctAnswers={question.correctAnswers[question.questionType]}
              reset={() => setSelectedOption({})}
              options={question.options}
              answers={selectedOption.optionId}
              editMode={edit}
              openEdit={openEdit}
              delete={() => deleteQuestion(question._id)}
              isPraticeSession={isPraticeSession}
              staff={{
                name: question.creatorId?.name,
                schoolName: question.schoolId?.name,
              }}
            >
              <div className="mcqCard">
                <div
                  className="mcqCard__left"
                  style={
                    isPraticeSession
                      ? {
                          marginTop: "16px",
                          fontSize: isSmallScreen ? "16px" : "",
                        }
                      : { display: "flex", alignItems: "center" }
                  }
                >
                  <div style={{ minWidth: "fit-content" }}>
                    Q{5 * (page - 1) + index}.&nbsp;
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: htmlDecode(question.question),
                    }}
                  ></div>

                  {isChecked ? (
                    <Checkbox
                      style={{ marginLeft: "auto" }}
                      className={isChecked ? "checkbox ot" : "checkbox ps"}
                      checked={
                        reviewQuestion.findIndex(
                          (x) => x._id === question._id,
                        ) > -1
                          ? true
                          : false
                      }
                      onClick={(e) => {
                        if (e.target.checked) {
                          chaptersState.push(question.chapterId);
                          setChaptersState(chaptersState);
                          topicsState.push(question.topicId);
                          setTopicsState(topicsState);
                          //    getTotalMarks(0)
                          setChecked(true);
                          setReviewQuestion((arr) => [...arr, { ...question }]);
                          getTotalMarks(question.marks || 0);
                        } else {
                          // getTotalMarks(0)
                          setCheckMarksState(true);
                          setChecked(false);
                          const index = reviewQuestion.findIndex(
                            (x) => x._id === question._id,
                          );
                          getTotalMarks(-reviewQuestion[index]?.["marks"]);
                          reviewQuestion.splice(index, 1);
                          setReviewQuestion(reviewQuestion);

                          const i = chaptersState.findIndex(
                            (x) => x === question.chapterId,
                          );
                          chaptersState.splice(i, 1);
                          setChaptersState(chaptersState);

                          const j = topicsState.findIndex(
                            (x) => x === question.chapterId,
                          );
                          topicsState.splice(j, 1);
                          setTopicsState(topicsState);
                        }
                      }}
                    />
                  ) : (
                    ""
                  )}
                </div>
                {question.cognitive ? (
                  <div className="mcqCard__right">
                    <span
                      className={
                        isPraticeSession
                          ? "difficulty_status bg_ps"
                          : "difficulty_status bg_ot"
                      }
                    >
                      <CognitiveIcon />
                      {question.cognitive}
                    </span>
                  </div>
                ) : null}
              </div>
              <div className="question-description">
                {question.images?.assertImg ? (
                  <QuestionImg image={question.images?.assertImg} />
                ) : null}
                <div
                  className="question-text"
                  style={{
                          fontSize: isSmallScreen ? "1rem" : "1.35rem",
                        }}
                >
                  <div
                    style={{ display: "flex", gap: "5px" }}
                    dangerouslySetInnerHTML={{
                      __html: `<span>${question.language === "hindi"?"कथन (A)":"Assertion (A)"}: </span> <div>${htmlDecode(
                        question?.description?.assertion || "",
                      )}</div>`,
                    }}
                  ></div>
                </div>
              </div>
              <div className="question-description">
                {question.images?.reasonImg ? (
                  <QuestionImg image={question.images?.reasonImg} />
                ) : null}
                <div
                  className="question-text"
                  style={{
                          fontSize: isSmallScreen ? "1rem" : "1.35rem",
                        }}
                >
                  <div
                    style={{ display: "flex", gap: "5px" }}
                    dangerouslySetInnerHTML={{
                      __html: `<span>${question.language === "hindi"?"कारण (R)":"Reasoning (R)"}:</span> <div>${htmlDecode(
                        question?.description?.reasoning || "",
                      )}</div>`,
                    }}
                  ></div>
                </div>
              </div>

              <div className="main_div" style={{ marginTop: "20px" }}>
                <div
                  className="mcq"
                  style={
                    isSmallScreen
                      ? { width: "100%" }
                      : { width: "80%" }
                  }
                >
                  <Option
                    isPraticeSession={isPraticeSession}
                    optionId={question.options[0].optionId}
                    value={htmlDecode(question.options[0]?.value || "")}
                    image={question.images?.op1}
                    isSelected={isSelected(question.options[0])}
                    selectOption={() => setSelectedOption(question.options[0])}
                  />

                  <Option
                    isPraticeSession={isPraticeSession}
                    optionId={question.options[1].optionId}
                    value={htmlDecode(question.options[1].value)}
                    image={question.images?.op2}
                    isSelected={isSelected(question.options[1])}
                    selectOption={() => setSelectedOption(question.options[1])}
                  />

                  <Option
                    isPraticeSession={isPraticeSession}
                    optionId={question.options[2].optionId}
                    value={htmlDecode(question.options[2].value)}
                    image={question.images?.op3}
                    isSelected={isSelected(question.options[2])}
                    selectOption={() => setSelectedOption(question.options[2])}
                  />

                  <Option
                    isPraticeSession={isPraticeSession}
                    optionId={question.options[3].optionId}
                    value={htmlDecode(question.options[3].value)}
                    image={question.images?.op4}
                    isSelected={isSelected(question.options[3])}
                    selectOption={() => setSelectedOption(question.options[3])}
                  />
                </div>
              </div>
            </QuestionChecker>
          </div>
        </div>
      </div>
      <div style={{ marginRight: "16px" }}></div>
    </>
  );
}
